import {IS_BETA} from './localization';

export default function registerBetaMiddleware(router) {
  router.beforeEach((to, from, next) => {
    const isBetaOnly = to.meta && to.meta.beta;

    if (isBetaOnly && !IS_BETA) {
      return next('/');
    }

    return next();
  });
}
